"use strict";
import {types} from 'Subschema';
const substitute = types.SubstituteMixin;

function legalLength(value, lengths) {
    return lengths.reduce(function (a, b) {
        return value.length === b || a;
    }, false);
}

export default function multilength$config(options) {
    if (!options.lengths) throw new Error('Missing required length for duallength validator');
    options = {
        type: 'multilength',
        dataType: 'string',
        message: `Length should be satisfy the number of required characters`,
        ...options
    };
    const msg = substitute(options.message);

    return function multilength(val, vm) {
        var value = val;
        if (options.dataType === 'number') {
            value = (val || '').replace(/\D+?/g, '');
        }

        if (value && !legalLength(value, options.lengths)) {
            const data = vm ? {...vm.getValue(), options} : {options};
            return {
                level: options.level,
                message: msg.format(data),
                length: val.length,
                type: options.type
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/validators/multilength.js
 **/